import { IconAdd } from '@consta/icons/IconAdd'
import { Button } from '@consta/uikit/Button'
import type { TextPropSize } from '@consta/uikit/Text'
import { Text } from '@consta/uikit/Text'
import cn from 'classnames'
import type { FC } from 'react'

import css from './Placeholder.css'
import type { Props } from './types'

const descriptionWithDefaultStyle = (text: string, size: TextPropSize = 's') => {
  return (
    <Text className={css.text} view="ghost" size={size}>
      {text}
    </Text>
  )
}

// TODO: Убрать
export const Placeholder: FC<Props> = ({
  className = '',
  title,
  description,
  descriptionSize,
  icon,
  buttonText,
  isButton,
  isButtonDisabled,
  onAddClick,
}) => {
  const descriptionWithStyle =
    typeof description === 'string'
      ? descriptionWithDefaultStyle(description, descriptionSize)
      : description

  const containerClass = cn(css.placeholder, className)

  return (
    <div className={containerClass}>
      {!!icon && <div className={css.icon}>{icon}</div>}
      {!!title && (
        <Text size="s" className={css.title} weight="bold" view="primary">
          {title}
        </Text>
      )}
      {descriptionWithStyle}
      {!!isButton && (
        <Button
          view="ghost"
          label={buttonText}
          iconLeft={IconAdd}
          iconSize="s"
          onlyIcon={!buttonText}
          disabled={isButtonDisabled}
          onClick={onAddClick}
        />
      )}
    </div>
  )
}
